import React, { useEffect, useRef, useState } from "react"
import styles from "./Files.module.scss"
import axios from "axios"
import { API_ROUTE } from "../../../../utils"
import { UserInterface } from "../../../../App"

const Files: React.FC<{
    newAppSpace: any
    setActiveAppSpace: any
    setUser: any
    user: UserInterface
    createFile: string
}> = ({ newAppSpace, setActiveAppSpace, setUser, user, createFile }) => {
    const [loading, setLoading] = useState(false)
    const fileUploadRef = useRef<HTMLInputElement>(null)
    const [search, setSearch] = useState<string>("")

    async function uploadFileAndUpdateUser(file: any, content: string) {
        setLoading(true)
        const response = await axios.post(`${API_ROUTE}/upload-file`, {
            ...file,
            content: content,
        })

        const renew = await axios.post(`${API_ROUTE}/verify-user`, {
            _id: response.data._id,
            authToken: response.data.authToken,
        })

        setUser(renew.data)
        newAppSpace({ ...file, fileId: response.data.fileId })
        setLoading(false)
    }

    const createNewFile = async (type: string) => {
        uploadFileAndUpdateUser(
            {
                owner: user._id,
                authToken: user.authToken,
                name: type === "doc" ? "Document" : "Spreadsheet",
                size: 10,
                type,
                lastModified: Date.now(),
                created: Date.now(),
            },
            `data:text/plain;base64,${type === "doc" ? btoa("<h1>Document</h1>") : btoa("{}")}`
        )
    }

    const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files && event.target.files[0]
        if (file) {
            if (
                file?.type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ) {
                const reader = new FileReader()
                reader.onload = async (e) => {
                    try {
                        const processed = await axios.post(`${API_ROUTE}/process-temp-save-docx`, {
                            content: e.target?.result as string,
                        })

                        uploadFileAndUpdateUser(
                            {
                                owner: user._id,
                                authToken: user.authToken,
                                name: file.name,
                                size: file.size,
                                type: "docx",
                                lastModified: Date.now(),
                                created: Date.now(),
                            },
                            processed.data
                        )
                    } catch (error) {
                        console.log(error)
                    }
                }
                reader.readAsBinaryString(file)
                return
            }
            const reader = new FileReader()
            reader.onload = async (e) => {
                try {
                    uploadFileAndUpdateUser(
                        {
                            owner: user._id,
                            authToken: user.authToken,
                            name: file.name,
                            size: file.size,
                            type: file.type || "unknown",
                            lastModified: file.lastModified,
                            created: file.lastModified,
                        },
                        e.target?.result as string
                    )
                } catch (error) {
                    console.log(error)
                }
            }
            reader.readAsDataURL(file)
        }
    }

    const deleteFile = async (file: any) => {
        try {
            await axios.delete(`${API_ROUTE}/delete-file`, {
                data: {
                    fileId: file.fileId,
                    owner: user._id,
                    authToken: user.authToken,
                },
            })

            const renew = await axios.post(`${API_ROUTE}/verify-user`, {
                _id: user._id,
                authToken: user.authToken,
            })

            setUser(renew.data)
            setActiveAppSpace({})
        } catch (error) {}
    }

    const getFileColor = (type: string) => {
        switch (type) {
            case "application/pdf":
                return "#FF0000"
            case "doc":
                return "#6578D8"
            case "docx":
                return "#6578D8"
            case "sheet":
                return "#5E961F"
            default:
                return "#999"
        }
    }

    const bytesToReadable = (bytes: number) => {
        const sizes = ["Bytes", "KB", "MB", "GB", "TB"]
        if (bytes === 0) return "0 Byte"
        const i = Math.floor(Math.log(bytes) / Math.log(1024))
        return Math.round(bytes / Math.pow(1024, i)) + " " + sizes[i]
    }

    const readableFileDate = (date: number) => {
        const d = new Date(date)
        return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`
    }

    useEffect(() => {
        if (createFile) {
            createNewFile(createFile)
            // eslint-disable-next-line react-hooks/exhaustive-deps
            createFile = ""
        }
    }, [createFile])

    const sampleFiles = [
        {
            name: "French Revolution ESSAY",
            size: 10,
            type: "doc",
            lastModified: Date.now(),
            created: Date.now(),
            fileId: "french",
        },
        {
            name: "Russian Revolution ESSAY",
            size: 10,
            type: "doc",
            lastModified: Date.now(),
            created: Date.now(),
            fileId: "russian",
        },
        {
            name: "Ear Anatomy",
            size: 59239,
            type: "test",
            lastModified: Date.now(),
            created: Date.now(),
            fileId: "image",
        },
        {
            name: "Sales 2014-2020",
            size: 10,
            type: "sheet",
            lastModified: Date.now(),
            created: Date.now(),
            fileId: "sheet",
        },
    ]

    return (
        <div className={styles.Files}>
            <input type="file" hidden ref={fileUploadRef} onChange={handleFileUpload} />
            <div className="flex" style={{ justifyContent: "space-between" }}>
                <input
                    type="search"
                    className={styles.search}
                    name="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search files..."
                />
            </div>

            <br />

            <div className="flex" style={{ justifyContent: "space-between" }}>
                <button
                    onClick={() => {
                        if (fileUploadRef.current) fileUploadRef.current.click()
                    }}>
                    {loading ? (
                        <div className="flex">
                            <div className="loader"></div>
                            <span>Uploading...</span>
                        </div>
                    ) : (
                        <div className="flex">
                            <i className="material-symbols-rounded">attach_file</i>
                            Upload
                        </div>
                    )}
                </button>

                <div className="flex">
                    <button onClick={() => createNewFile("doc")}>
                        <i className="material-symbols-rounded">add</i>
                        Doc
                    </button>

                    <button style={{ background: "green" }} onClick={() => createNewFile("sheet")}>
                        <i className="material-symbols-rounded">add</i>
                        Sheet
                    </button>
                </div>
            </div>

            <br />

            <div className="flex" style={{ gap: "10px" }}>
                <i style={{ color: "#ffb300" }} className="material-symbols-rounded">
                    folder_open
                </i>
                <span>/</span>
            </div>

            <div className="flex" style={{ marginLeft: "3rem", gap: "10px" }}>
                <i style={{ color: "#ffb300" }} className="material-symbols-rounded">
                    folder_open
                </i>
                <span>Samples</span>
            </div>

            {sampleFiles
                ?.filter((file: any) => file.name.toLowerCase().includes(search.toLowerCase()))
                .map((file: any, index: number) => {
                    return (
                        <div
                            key={index}
                            style={{ marginLeft: "5rem" }}
                            onClick={() => newAppSpace(file)}
                            className={styles.file}>
                            <div className="flex">
                                <div
                                    style={{
                                        background: getFileColor(file.type),
                                    }}
                                    className={styles.fileType}></div>
                                <span>{file.name}</span>
                            </div>
                            <span
                                onClick={(e) => {
                                    e.stopPropagation()
                                    deleteFile(file)
                                }}
                                className={styles.info}>
                                Delete
                            </span>
                            <span className={styles.info}>{bytesToReadable(file.size)}</span>
                            <span className={styles.info}>{readableFileDate(file.created)}</span>
                        </div>
                    )
                })}

            <br />

            {user.files
                ?.filter((file: any) => file.name.toLowerCase().includes(search.toLowerCase()))
                .map((file: any, index: number) => {
                    return (
                        <div
                            key={index}
                            style={{ marginLeft: "3rem" }}
                            onClick={() => newAppSpace(file)}
                            className={styles.file}>
                            <div className="flex">
                                <div
                                    style={{
                                        background: getFileColor(file.type),
                                    }}
                                    className={styles.fileType}></div>
                                <span>{file.name}</span>
                            </div>
                            <span
                                onClick={(e) => {
                                    e.stopPropagation()
                                    deleteFile(file)
                                }}
                                className={styles.info}>
                                Delete
                            </span>
                            <span className={styles.info}>{bytesToReadable(file.size)}</span>
                            <span className={styles.info}>{readableFileDate(file.created)}</span>
                        </div>
                    )
                })}
        </div>
    )
}

export default Files
